
export function getKVLayerByBookmarkPresentationID(bookmarkPresentationID) {
    return window.layersLoaded.find(layer => layer.BookmarkPresentationID === parseInt(bookmarkPresentationID))
}

export function getKVLayerByDomainIDAndPresentationID(domainID, presentationID) {
    return window.layersLoaded.find(layer => layer.DomainID === parseInt(domainID) && layer.PresentationID === parseInt(presentationID))
}
